import { CollapsibleTool } from "../app/CollapsiblePanel";
import type { Journey } from "../contract/types";
import { AnticipationPanel } from "./AnticipationPanel";
import { CrossingPanel } from "./CrossingPanel";
import { EndOfServicePanel } from "./EndOfServicePanel";
import { NextPassagesPanel } from "./NextPassagesPanel";
import { ScopeSwitch } from "./ScopeSwitch";
import { SortieReallocationPanel } from "./SortieReallocationPanel";
import { useToolsScope } from "./toolsScope";

/**
 * Les outils d'aide à la décision, avec leur commutateur de portée — partagés
 * par la colonne « Véhicule & Outils » de la carte pilote et le panneau
 * « Outils » du cockpit (qui dupliquaient la même liste).
 *
 *  - **Réseau entier** : le moteur balaie le réseau et propose dynamiquement ses
 *    mesures ;
 *  - **Véhicule** (d'emblée dès qu'un véhicule est sélectionné) : les mêmes outils,
 *    restreints à ce véhicule.
 *
 * Tout est consultatif — aucune écriture (CLAUDE.md, « Nature du produit »).
 * `storagePrefix` distingue l'état replié/déplié de chaque hôte.
 */
export function RegulationTools({
  journey,
  storagePrefix,
  onSelectJourney,
  anticipationCount,
  onAnticipationCount,
}: {
  /** Véhicule sélectionné, s'il y en a un. */
  journey: Journey | null;
  storagePrefix: string;
  onSelectJourney: (id: string) => void;
  anticipationCount: number;
  onAnticipationCount: (n: number) => void;
}) {
  const { scope, mode, setMode } = useToolsScope(journey);

  return (
    <>
      <ScopeSwitch mode={mode} onMode={setMode} journey={journey} />
      <CollapsibleTool title="Aide à la décision" storageKey={`${storagePrefix}.turnback.open`} badge={anticipationCount}>
        <AnticipationPanel scope={scope} onSelectJourney={onSelectJourney} onCount={onAnticipationCount} />
      </CollapsibleTool>
      <CollapsibleTool title="Calcul de croisement" storageKey={`${storagePrefix}.crossing.open`}>
        <CrossingPanel scope={scope} />
      </CollapsibleTool>
      <CollapsibleTool title="Calcul de passage" storageKey={`${storagePrefix}.nextpass.open`}>
        <NextPassagesPanel scope={scope} />
      </CollapsibleTool>
      <CollapsibleTool title="Calcul de véhicule rentrant" storageKey={`${storagePrefix}.eos.open`}>
        <EndOfServicePanel scope={scope} />
      </CollapsibleTool>
      <CollapsibleTool title="Répartition des sorties" storageKey={`${storagePrefix}.sortiereal.open`}>
        <SortieReallocationPanel scope={scope} />
      </CollapsibleTool>
    </>
  );
}
